/**
 * The only values this app keeps in the browser: two screen preferences of this device (46 Spec 3.1, 3.2, 5),
 * and the share reader's view settings (`share.reader`, 50 Spec 5.3).
 * Upload resumption is account scoped and expires with its upload capability. Storage that throws (private mode, blocked) falls back to the defaults.
 */
export type PrefKey =
  | "volgo.sidebar"
  | "volgo.cardSize"
  | "volgo.player"
  | `volgo.upload.${number}`
  | "share.reader";

export function readPref(key: PrefKey): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writePref(key: PrefKey, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    // the choice still holds for this visit
    return false;
  }
}
